import { r } from './useApi';
import { keeper } from './utils';
import { normalizeBySchema } from './useDataModels';

export const validate = async (data) => {
    let method = 'post',
        searchEndpoint = '/v1/external/multiDocument/validate',
        endpoint = `${keeper('apiUrl')}/v1/external/multiDocument/validate`;

    const dataModel = await normalizeBySchema(searchEndpoint, method, data);

    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
    });

    return res;
};

export const process = async (data, zip = false) => {
    let method = 'post',
        zipEndpoint = zip === false ? '' : '/zip',
        searchEndpoint = `/v1/external/multiDocument/validate${zipEndpoint}`,
        endpoint = `${keeper('apiUrl')}/v1/external/multiDocument${zipEndpoint}`;

    const dataModel = await normalizeBySchema(searchEndpoint, method, data);

    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
        headers: {
            Accept: 'application/zip',
        },
        responseType: 'blob',
    });

    return res;
};

export const processZip = async (data) => {
    return await process(data, true);
};

export const useMultidocument = () => {
    return {
        validate: validate,
        process: process,
        processZip: processZip,
    };
};

export default useMultidocument;
